import React from "react";

const ContractDelete = () => {
  return <h1>Contract Delete</h1>;
};

export default ContractDelete;
